import React, { Component } from 'react';
import { Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';

class Information extends Component {
    state = {
        data: {},
        loading: false,
    }
    
    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: {
                userId: sessionStorage.userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { user, experiences = [], hospitals = [], teachers = [], positiveTime, clinicalTrialExperienceYears, userPromotions = [] } = res;
                const { userDetail } = user || {};
                const { name, status, joinTime, employeeCode } = userDetail || {};
                const userPromotion = userPromotions.map((item, index) => <div key={index}>{item}</div>);
                const data = {
                    ...user,
                    teachers,
                    hospitals,
                    experiences,
                    employeeCode,
                    positiveTime,
                    userPromotion,
                    userCompellation: name,
                    clinicalTrialExperienceYears,
                    joinTime: joinTime ? joinTime.slice(0, 10) : '',
                    status: status ?  status === 'ACTIVE' ? '在职' : '离职': '',
                };

                this.setState({
                    data,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const {
            data: {
                employeeCode,
                userCompellation,
                positionName,
                enterpriseDepartmentName,
                leaderCode,
                leaderName,
                userMobile,
                userEmail,
                cityName,
                status,
                joinTime,
                positiveTime,
                userPromotion,
                clinicalTrialExperienceYears,
                teachers = [],
                hospitals = [],
                experiences = [],
            },
            loading,
        } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='information' />
                <div className="main">
                    <Spin spinning={loading} style={{ marginBottom: 20 }}>
                        <table cellPadding='0' cellSpacing='0' className="distribute information">
                            <tbody>
                                <tr>
                                    <td className="distribute_td_left">工号：</td>
                                    <td className="distribute_td_right">{employeeCode}</td>
                                    <td className="distribute_td_left">姓名：</td>
                                    <td className="distribute_td_right">{userCompellation}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">职位/级别：</td>
                                    <td className="distribute_td_right">{positionName}</td>
                                    <td className="distribute_td_left">部门：</td>
                                    <td className="distribute_td_right">{enterpriseDepartmentName}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">主管领导工号：</td>
                                    <td className="distribute_td_right">{leaderCode}</td>
                                    <td className="distribute_td_left">主管领导姓名：</td>
                                    <td className="distribute_td_right">{leaderName}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">手机号码：</td>
                                    <td className="distribute_td_right">{userMobile}</td>
                                    <td className="distribute_td_left">邮箱：</td>
                                    <td className="distribute_td_right">{userEmail}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">工作城市：</td>
                                    <td className="distribute_td_right">{cityName}</td>
                                    <td className="distribute_td_left">状态：</td>
                                    <td className="distribute_td_right">{status}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">入职时间：</td>
                                    <td className="distribute_td_right">{joinTime}</td>
                                    <td className="distribute_td_left">带教老师工号：</td>
                                    <td className="distribute_td_right">
                                        {
                                            teachers.map((item, index) =>
                                                <span key={item.userTeacherId}>
                                                    {item.teacherCode}
                                                    {(index < teachers.length - 1 ? '；' : '')}
                                                    {(index + 1) % 3 === 0 ? <br /> : ''}
                                                </span>
                                            )
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">带教老师姓名：</td>
                                    <td className="distribute_td_right">
                                        {
                                            teachers.map((item, index) =>
                                                <span key={item.userTeacherId}>
                                                    {item.teacherName}
                                                    {(index < teachers.length - 1 ? '；' : '')}
                                                    {(index + 1) % 3 === 0 ? <br /> : ''}
                                                </span>
                                            )
                                        }
                                    </td>
                                    <td className="distribute_td_left">转正时间：</td>
                                    <td className="distribute_td_right">{positiveTime}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">晋升时间：</td>
                                    <td className="distribute_td_right">{userPromotion}</td>
                                    <td className="distribute_td_left">临床试验经验年限：</td>
                                    <td className="distribute_td_right">{clinicalTrialExperienceYears}{clinicalTrialExperienceYears >= 0 ? '个月' : ''}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left">涉及项目领域/疾病：</td>
                                    <td className="distribute_td_right">
                                        {
                                            experiences.map((item, index) => {
                                                const { investigationAreaName, diseaseName } = item;
                                                return (
                                                    <span key={index}>
                                                        {investigationAreaName}-{diseaseName}
                                                        {(index < experiences.length - 1 ? '；' : '')}
                                                        {((index + 1) % 2) === 0 ? <br /> : ''}
                                                    </span>
                                                )
                                            })
                                        }
                                    </td>
                                    <td className="distribute_td_left">工作所在医院：</td>
                                    <td className="distribute_td_right">
                                        {
                                            hospitals.map((item, index) => {
                                                const { hospitalId, hospitalName } = item;
                                                return (
                                                    <span key={hospitalId}>
                                                        {hospitalName}
                                                        {(index < hospitals.length - 1 ? '；' : '')}
                                                        <br />
                                                    </span>
                                                )
                                            })
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Spin>
                </div>           
            </div>
        )
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/components/personal/information/index.js